var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.00123C4.22386 3.00123 4 2.77737 4 2.50123C4 2.25577 4.17688 2.05163 4.41013 2.00929L4.5 2.00123L15.5 2.00123C15.7761 2.00123 16 2.22509 16 2.50123C16 2.74669 15.8231 2.95084 15.5899 2.99318L15.5 3.00123L4.5 3.00123ZM9.99986 17.999C9.7544 17.999 9.5503 17.822 9.50803 17.5888L9.5 17.4989L9.504 5.70502L5.85859 9.35336C5.68519 9.52708 5.41578 9.54661 5.22079 9.4118L5.15149 9.35401C4.97776 9.1806 4.95823 8.91119 5.09304 8.7162L5.15083 8.6469L9.64255 4.1469C9.71505 4.07427 9.80433 4.02859 9.89793 4.00987L10.0039 4.00013C10.1649 4.00013 10.3081 4.07625 10.3995 4.19445L14.8561 8.64632C15.0515 8.84145 15.0518 9.15803 14.8566 9.35343C14.6832 9.52712 14.4138 9.5466 14.2188 9.41174L14.1495 9.35393L10.504 5.71302L10.5 17.4992C10.4999 17.7753 10.276 17.999 9.99986 17.999Z",
    fill: "#0358A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7d612d7daae74dfdd88e0c008999f9b6.svg";
export { ForwardRef as ReactComponent };